import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function PointSales() {
  return (
    <>
<Features docname="Point of Sales for Retail Outlets"/>
<Advantages docname="Point of Sales for Retail Outlets"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default PointSales;
